const list = [
  {
    id: 1,
    title:'运营托管模式解决方案',
    englishTitle:'Operational custody mode solution',
    desc:'许多中职校选择与第三方供应商合作进行校园网建设，而许多供应商由于运营管理不足,导致无力提供后续校园网运营服务，校园网后续如何运营成为校方亟需解决的难题。',
    img:'image/solution/detail.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-one1.png',
      difficult: [
        {title: "运营与困境", desc: "校园网运营效果不理想，供应商运维服务无积极性，学生用户无粘性，形成恶性循环,"},
        {title: "功能单一", desc: "校园网现有认证计费系统功能单一，学生用户购买意向不强；"},
        {title: "经验不足", desc: "供应商运营管理经验不足，用户转化率提升困难；"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联拥有丰富的校园网运营管理经验，运营管理平台支持接入多种品牌、类型认证计费系统，帮助校园网供应商提高运营收益。",
    detail: [
      {
        title:"兼容性强",
        img:'image/solution/detail-one2.png',
        desc:'网联运营管理平台支持接入各类标准协议认证计费平台，同时支持定制接入部分非标准协议' +
          '认证计费平台。'
      },
      {
        title:"计费灵活",
        img:'image/solution/detail-one3.png',
        desc:'校园网套餐计费方式灵活，支持免费、代拨、付费+代拨方式，付费套餐支持按天数/速率/终' +
          '端数/买赠进行购买，能够有效提高学生用户购买意向；',
      },
      {
        title:"专业运营",
        img:'image/solution/detail-one4.png',
        desc:'拥有专业运营管理团队，项目当地团队会定期通过迎新、地推等方式提升校园网用户转换率；',
      },
    ]
  },
  {
    id: 2,
    title:'自运营模式解决方案',
    englishTitle:'Self operation mode solution',
    desc:'中职校校园网是校园信息化建设的重要支柱，但如何建造一张安全可靠、高效运营的校园网络成为目前许多中职校亟需解决的核心问题',
    img:'image/solution/detail-two-bg.png',
    difficult: {
      difficultTitle: '困难与挑战',
      difficultSecondTitle: "Difficulties and challenges",
      difficultImageSrc: 'image/solution/detail-two1.png',
      difficult: [
        {title: "资金不足", desc: "校方建设校园网资金不足，只能优先保障办公网的建设，学生宿舍以及公共区域校园网无多余资金建设"},
        {title: "运营风险", desc: "校方引入的第三方供应商建设校园网往往采购其他厂家设备，可能存在故障处理不及时、运营效果不理想等问题；"},
        {title: "数据割裂", desc: "学校自建办公网与供应商承建校园网数据割裂，造成网管运维不便捷、师生使用体验不佳的问题；"}
      ]
    },
    solutionTitle:"方案价值",
    solutionSecondTitle:"Value of the plan",
    products:[1,2,3],
    solutionSecondDesc:"网联拥有丰富的校园网运营管理经验，运营管理平台支持接入多种品牌、类型认证计费系统，帮助校园网供应商提高运营收益。",
    detail: [
      {
        title:"经验丰富",
        img:'image/solution/detail-self1.png',
        desc:'拥有十年中职学校校园网规、建、运、维经验，获得腾讯、广发信德、招商银科、分享投资、' +
          '中国风险投资有限公司、吉富创投等国内知名机构数亿元投资，于2016年新三板挂牌。',
      },
      {
        title:"技术自主性",
        img:'image/solution/detail-self2.png',
        desc:'自研从平台、设备到应用的全套产品，拥有专项项目经理与多种线上报障通道，能够及时处理' +
          '各类故障问题；'
      },
      {
        title:"一体化简化",
        img:'image/solution/detail-self3.png',
        desc:'提供校园有线无线一体化建设方案，简化网管运维难度，提升师生使用校园网体验；',
      },
      {
        title:"套餐灵活性",
        img:'image/solution/detail-self4.png',
        desc:'校园网套餐计费方式灵活，用户能够按照天数/速率/终端数自由选择套餐。',
      },
    ]
  }
]

export default list



// WEBPACK FOOTER //
// ./src/pages/solution/detailData.js